<template>
  <nav class="flex h-full min-h-0 flex-col">
    <div class="flex flex-1 flex-col p-4 [&>[data-slot=section]+[data-slot=section]]:mt-8">
      <div data-slot="section" class="flex flex-col gap-0.5">
        <AppSidebarItem v-for="item in mainNav" :type="item.type" :to="item?.to" :label="item?.label" :icon="item?.icon" iconSize="large" :function="item?.function" />
      </div>
      <div v-if="user" data-slot="section" class="flex flex-col gap-0.5">
        <h3 class="nba mb-1 px-2 text-xs/6 font-medium text-zinc-400">Play</h3>
        <AppSidebarItem v-for="item in links" :type="item.type" :to="item?.to" :label="item?.label" :icon="item?.icon" :function="item?.function" />
      </div>
      <div aria-hidden="true" class="mt-8 flex-1 lg:hidden"></div>
      <div data-slot="section" class="flex flex-col gap-0.5 lg:hidden">
        <AppSidebarItem v-for="item in supportItems" :type="item.type" :to="item?.to" :label="item?.label" :icon="item?.icon" :function="item?.function" />
      </div>
    </div>
  </nav>
</template>

<script setup>
const user = useSupabaseUser()

let loginLink = []
if (!user.value) {
  loginLink = [
    {
      type: 'link',
      to: '/login',
      label: 'Login',
      icon: 'heroicons:user-20-solid',
    },
    {
      type: 'link',
      to: '/join',
      label: 'Get started',
      icon: 'heroicons:arrow-long-right-20-solid',
    }
  ]
}

const mainNav = [
  {
    type: 'link',
    to: '/',
    label: 'Home',
    icon: 'heroicons:home-20-solid',
  },
  {
    type: 'link',
    to: '/explore',
    label: 'Explore',
    icon: 'heroicons:map-20-solid'
  },
  {
    type: 'link',
    to: '/collections',
    label: 'Collections',
    icon: 'heroicons:view-columns-20-solid',
  },
  ...loginLink
]

const links = [
  {
    type: 'link',
    to: '/play',
    label: 'Dashboard'
  },
  {
    type: 'link',
    to: '/play/collections',
    label: 'Collections'
  },
  {
    type: 'link',
    to: '/play/explore',
    label: 'Explore'
  },
  {
    type: 'link',
    to: '/play/playlists',
    label: 'My playlists',
  },
  {
    type: 'link',
    to: '/play/favorites',
    label: 'Favorites'
  }
]

const supportItems = [
  // {
  //   type: 'link',
  //   to: '/changelog',
  //   label: 'Changelog',
  //   icon: 'heroicons:square-3-stack-3d-20-solid',
  // },
  {
    type: 'link',
    to: '/support',
    label: 'Support',
    icon: 'heroicons:chat-bubble-oval-left-20-solid',
  }
]

</script>